import clsx from 'clsx';
import { ArrowLeft, Bot, Building2, DatabaseBackup, Flag, Gauge, LifeBuoy, Package, Server, Settings, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, Outlet } from 'react-router';
import { LanguageSwitcher, Logo } from '../components/brand';

const ITEMS = [
  { to: '/admin', key: 'admin.nav.overview', icon: Gauge, end: true },
  { to: '/admin/companies', key: 'admin.nav.companies', icon: Building2 },
  { to: '/admin/users', key: 'admin.nav.users', icon: Users },
  { to: '/admin/plans', key: 'admin.nav.plans', icon: Package },
  { to: '/admin/flags', key: 'admin.nav.flags', icon: Flag },
  { to: '/admin/ai', key: 'admin.nav.ai', icon: Bot },
  { to: '/admin/support', key: 'admin.nav.support', icon: LifeBuoy },
  { to: '/admin/operations', key: 'admin.nav.operations', icon: Server },
  { to: '/admin/backups', key: 'admin.nav.backups', icon: DatabaseBackup },
  { to: '/admin/settings', key: 'admin.nav.settings', icon: Settings },
];

export function AdminLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-14 max-w-[1400px] items-center justify-between gap-4 px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <Logo to="/admin" />
            <span className="rounded-md bg-slate-900 px-2 py-0.5 text-xs font-semibold text-white">Super Admin</span>
          </div>
          <div className="flex items-center gap-2">
            <LanguageSwitcher compact />
            <Link to="/app" className="flex items-center gap-1 rounded-lg px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-100">
              <ArrowLeft className="size-4" /> {t('admin.backToApp')}
            </Link>
          </div>
        </div>
        <nav className="mx-auto flex max-w-[1400px] gap-1 overflow-x-auto px-4 sm:px-6">
          {ITEMS.map(({ to, key, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => clsx('-mb-px flex items-center gap-2 border-b-2 px-3 py-2.5 text-sm font-medium whitespace-nowrap',
                isActive ? 'border-brand text-brand-700' : 'border-transparent text-slate-500 hover:text-slate-800')}>
              <Icon className="size-4" /> {t(key)}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6"><Outlet /></main>
    </div>
  );
}
